import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AuthService } from '@shared/services/auth.service';
import _ from 'lodash';

@Directive({ selector: '[appAccess]' })
export class AccessDirective implements OnInit {
  @Input() appAccess: string[] = [];

  constructor(
    private el: ElementRef,
    private auth: AuthService,
  ) {}

  ngOnInit() {
    const user = this.auth.user;
    // Item is hidden by default
    this.el.nativeElement.style.display = 'none';

    // If no ACL, show always
    if (!this.appAccess || this.appAccess.length === 0) {
      this.el.nativeElement.style.display = 'inherit';
      return;
    }

    // If ACL found, show
    for (const feature of user.features) {
      if (_.indexOf(this.appAccess, feature) > -1) {
        this.el.nativeElement.style.display = 'inherit';
        break;
      }
    }
  }
}
